import React, { useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { layouts, textblocks } from 'seal-ui-components';
import { isAfterOrEqual } from '@Utils/versionUtils';
import { CustomSingleSelect } from '@Components/UI/Dropdowns';
import { setDigAppFlags, addToFavorite, deleteFromFavorite } from '@Actions/scoreCardActions';
import { usePermissions } from '@Context';
import { useSelector, useDispatch } from 'react-redux';
import style from './SubmitForAnalysis.style';
import SubmitForAnalysisButton from './components/SubmitForAnalysisButton';
import { DocumentStatus } from '@Constants/status';

const SubmitForAnalysis = ({ className, history }) => {
    const { version, activeSystem, sealSystems, user } = useSelector(state => state.auth);
    const digAppsSelectionInput = useSelector(state => state.digAppsSelector.digAppsSelectionInput);

    const sealServerName = activeSystem && sealSystems[activeSystem].name;
    const { documentStatus, importedAt } = useSelector(state => state.document);
    const userId = user ? user.id : undefined;
    const [togglingFavorites, setTogglingFavorite] = useState(false);

    const { haveAccessToScorecardsPage } = usePermissions();

    const dispatch = useDispatch();

    const showSelector = isAfterOrEqual('7.2.1', version) && haveAccessToScorecardsPage;
    const showFavorite = isAfterOrEqual('8.1.0.0', version);

    const onFavoriteClick = async (digApp, isFav) => {
        try {
            setTogglingFavorite(true);

            isFav ? await deleteFromFavorite(digApp, userId) : await addToFavorite(digApp, userId);

            const updateDigApps = { ...digAppsSelectionInput };

            updateDigApps[digApp.text].isFavorite = !updateDigApps[digApp.text].isFavorite;

            dispatch(setDigAppFlags(updateDigApps));

            setTogglingFavorite(false);
        } catch (error) {
            setTogglingFavorite(false);
        }
    };

    return (
        <div className={className}>
            <layouts.VerticalBox align="right">
                {importedAt && documentStatus === DocumentStatus.PROCESSED ? (
                    <textblocks.Label>
                        {`Analyzed ${moment
                            .utc(importedAt)
                            .local()
                            .fromNow()} by `}
                        <b>{sealServerName}</b>
                    </textblocks.Label>
                ) : (
                    <textblocks.Label>
                        {'Logged in to '}
                        <b>{sealServerName}</b>
                    </textblocks.Label>
                )}
            </layouts.VerticalBox>
            <layouts.HorizontalBox gap={'xs'}>
                {showSelector && (
                    <CustomSingleSelect
                        name="DigApp"
                        options={digAppsSelectionInput}
                        setOptions={input => dispatch(setDigAppFlags(input))}
                        defaultOpen={documentStatus === DocumentStatus.NOT_SUBMITTED}
                        onFavoriteClick={onFavoriteClick}
                        togglingFavorites={togglingFavorites}
                        showFavorite={showFavorite}
                    />
                )}
                <SubmitForAnalysisButton history={history} />
            </layouts.HorizontalBox>
        </div>
    );
};

export default styled(SubmitForAnalysis)`
    ${style};
`;
